import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
    margin-top: -8px;
`;

export const WarningTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    margin: 0;
`;

export const WarningTitleText = styled.h1`
    color: #ff0000;
    font-size: 1.5rem;
    font-weight: 600;
    margin-left: 10px;

    @media screen and (min-width: 769px) {
        font-size: 1.9rem;
        font-weight: 600;
    }
`;

export const Text = styled.p`
    margin: 5px 0;
    font-weight: 400;
    font-size: 1rem;
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
`;
